import React, { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import qrcode from "../../../assets/images/qrcode.svg";
import eyecloseicon from "../../../assets/images/eyecloseicon.svg";
import openeyeicon from "../../../assets/images/openeyeicon.svg";
import { useAuth } from '../../../firebase/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { multiFactor, TotpMultiFactorGenerator, TotpSecret } from 'firebase/auth';
import { QRCodeCanvas } from 'qrcode.react';
import { toast } from 'react-toastify'; // <-- added
import { BsFillEyeFill } from "react-icons/bs";
import { BsFillEyeSlashFill } from "react-icons/bs";

interface SetupMFAModalProps {
    show: boolean,
    handleClose: () => void,
}

const SetupMFAModal: React.FC<SetupMFAModalProps> = ({
    handleClose,
    show
}) => {

    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [secret, setSecret] = useState<TotpSecret | null>(null);
    const [uri, setUri] = useState("");
    const [code, setCode] = useState("");
    const [busy, setBusy] = useState(false);

    const [showCode, setShowCode] = useState(true);

    const Eye = BsFillEyeFill as any;
    const CloseEye = BsFillEyeSlashFill as any;

    useEffect(() => {
        const prepare = async () => {
            if (!currentUser) return;
            try {
                const mfUser = multiFactor(currentUser);
                const session = await mfUser.getSession();
                const totpSecret = await TotpMultiFactorGenerator.generateSecret(session);

                setSecret(totpSecret);
                setUri(
                    `otpauth://totp/Sprout%20App:${currentUser.email}?secret=${totpSecret.secretKey}&issuer=Sprout%20App`
                );
            } catch (error: any) {
                console.error("Failed to generate TOTP secret:", error);
                const message = error?.code === 'auth/requires-recent-login'
                    ? 'Please re-authenticate to set up MFA (sign out and sign in again).'
                    : (error?.message || 'Failed to generate MFA secret.');
                toast.error(message);
            }
        };
        prepare();
    }, [currentUser]);

    const enroll = async () => {
        if (!secret || !currentUser) {
            toast.error("Unable to activate MFA. Please try again.");
            return;
        }
        setBusy(true);
        try {
            const assertion =
                TotpMultiFactorGenerator.assertionForEnrollment(secret, code);
            await multiFactor(currentUser).enroll(assertion, "Authenticator App");
            toast.success("MFA activated.");
            handleClose();
        } catch (error: any) {
            console.error("Failed to enroll MFA:", error);
            const message = error?.code === 'auth/requires-recent-login'
                ? 'Please re-authenticate to activate MFA (sign out and sign in again).'
                : (error?.message || 'Failed to activate MFA.');
            toast.error(message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <Modal className='my_modal' size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Enable 2-Factor authentication
                    </Modal.Title>
                    <p style={{ fontSize: "14px", color: "#676767" }}>
                        Scan this QR code with Google Authenticator, Authy, etc.
                    </p>
                </Modal.Header>
                <Modal.Body>
                    <div className="qr_code text-center">
                        {uri && <QRCodeCanvas value={uri} size={200} />}
                    </div>
                    <Form.Group className="" controlId="exampleForm.ControlInput1">
                        <Form.Label>Verification Code</Form.Label>
                        <div style={{ position: "relative" }}>
                            <Form.Control
                                placeholder="Enter 6-digit code"
                                type={showCode ? "text" : "password"}
                                value={code}
                                onChange={(e) => {
                                    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 6);
                                    setCode(digitsOnly);
                                }}
                                maxLength={6}
                                inputMode="numeric"
                                style={{
                                    background: "#EFEFEF",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontStyle: "normal",
                                    fontSize: "14px",
                                    lineHeight: "16px",
                                    letterSpacing: "0px",
                                    width: "100%",
                                    height: "42px",
                                    borderRadius: "12px",
                                    border: "none",
                                    padding: "0 40px 0 10px", // space for eye icon
                                    opacity: 1
                                }}
                            />
                            {/* <img
                                src={showCode ? openeyeicon : eyecloseicon}
                                alt="eye"
                                onClick={() => setShowCode(prev => !prev)}
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    width: "20px",
                                    height: "20px"
                                }}
                            /> */}
                            <div
                                onClick={() => setShowCode(prev => !prev)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center border-l border-[#CFD9E0] pl-3 cursor-pointer"
                            >
                                {showCode ? (
                                    <Eye className="text-[#718096] text-xl" />
                                ) : (
                                    <CloseEye className="text-[#718096] text-xl" />
                                )}
                            </div>
                        </div>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={enroll}
                        disabled={busy || code.trim().length === 0}
                    >
                        {busy ? 'Activating...' : 'Activate MFA'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default SetupMFAModal